import gql from "graphql-tag";

export default gql`
  mutation deleteCreditHealthRating($friendly_entity_id: String!) {
    deleteCreditHealthRating(friendly_entity_id: $friendly_entity_id) {
      __typename
      id
      friendly_entity_id
      health_rating
      current
      user
      created_time
      modified_time
    }
  }
`;
